import { Component, OnDestroy, ViewChild, OnInit } from '@angular/core';
import { TransferHttpService, CacheItem, TenantConfig } from '../../../../../services/transfer-http/transfer-http.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PermissionsService } from '../../../../../services/permissions/permissions.service';
import { takeUntil, map, tap, take, finalize } from 'rxjs/operators';
import { Subject, Subscription, BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { QcObservations, QcObservationAttachments, QcObservationRequiredActions, QcObservationComments, QcDeficiencyTypes, QcResponsibleManagers, QcAreas, HrWorkSections, AllSites, QcRootCauses, QcOriginTypes, QcObservationXworkOrders, WoWorkOrders, QcObservationCommentTypes, QcInspectionReports, QcObservationXjobControlNumbers, Discrepancies } from 'src/models';
import { FormControl, NgForm, Validators } from '@angular/forms';
import * as moment from 'moment-mini';
import { DeficiencyEnum, ObservationTypeEnum, ObservationCommentTypeEnum, ObservationTypes } from '../../quality-control.classes';
import { AimsCommonConfirmDialogComponent, AimsCommonPopupEditorComponent, AimsCommonTableComponent, AimsCommonTableHeader, AimsCommonTableHeaderType, AimsCommonTablePermissions, TableRowDelete, TableRowUpdate } from '@aims/common-components';
import { DialogComponent } from 'src/app/services/message/message.enum';
import { MatDialog } from '@angular/material/dialog';
import { MessageService } from 'src/app/services/message/message.service';
import { RebuttalCommentDialogComponent } from './rebuttal-comment-dialog/rebuttal-comment-dialog.component';
import { FileUploader} from './file-uploader';
import { FileGridCmd, FileGridCmds } from 'src/app/components/new-grid-file-upload/new-grid-file-upload.component';


@Component({
  selector: 'observation',
  templateUrl: './observation.component.html',
  styleUrls: ['./observation.component.css']
})
export class ObservationComponent implements OnInit, OnDestroy {

  constructor(public transferHttp: TransferHttpService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private messageService: MessageService,
    public permissions: PermissionsService) {
  }


  commentTablePermissions: AimsCommonTablePermissions = {
    create: true,
    update: true,
    delete: false,
    filter: false
  };
  commentTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton' },
    { key: 'observationCommentTypeId', label: 'Comment Type', type: 'dynamic', validatorOrOpts: [Validators.required] },
    { key: 'comment', label: 'Comment', type: 'string', width: 400, validatorOrOpts: [Validators.required] },
    { key: 'commentDate', label: 'Commented On', type: 'date', editable: false },
    { key: 'commentById', label: 'Comment By', type: 'dynamic', editable: false },
    { key: 'attachment', label: 'Attachment', type: 'dynamic',
     formControl: (entity) => new FormControl(
          {
            value: null,
          },
        )
        },
    { key: 'attachmentAddedById', label: 'Attachment Added By', type: 'dynamic', editable: false },
  ];

  getNewComment() : QcObservationComments{
    var comment = new QcObservationComments();
    comment.commentDate = new Date();
    comment.observationCommentTypeId =ObservationCommentTypeEnum.internalOnly;
    return comment;
  }
  defaultComment: QcObservationComments = this.getNewComment();

 actionTablePermissions: AimsCommonTablePermissions = {
    create: true,
    update: false,
    delete: false,
    filter: false
  };
  actionTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton' },
    { key: 'orderNumber', label: '#', type: 'number', filter: false, editable: false },
    { key: 'requiredAction', label: 'Required Action(s)', type: 'string', width: 400, validatorOrOpts: [Validators.required, Validators.maxLength(4000)] },
    { key: 'completedOn', label: 'Completed On', type: 'date', },
    { key: 'completedById', label: 'Completed By', type: 'dynamic', editable: false },
    { key: 'certifiedOn', label: 'Certified On', type: 'date', },
    { key: 'certifiedById', label: 'Certified By', type: 'dynamic', editable: false },
  ];
  defaultAction: QcObservationRequiredActions = new QcObservationRequiredActions();

 attachmentsTablePermissions: AimsCommonTablePermissions = {
    create: true,
    update: false,
    delete: false,
    filter: false
  };
  attachmentsTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton' },
    { key: 'printOnQcInspectionReport', label: 'Print ?', type: 'boolean', width: 90 },
    { key: 'attachment', label: 'Attachment', type: 'dynamic', },
    { key: 'addedById', label: 'Added By', type: 'dynamic', editable: false },
  ];
  defaultAttachment: QcObservationAttachments = new QcObservationAttachments();

  woTablePermissions: AimsCommonTablePermissions = {
    create: true,
    update: false,
    delete: false,
    filter: false
  };
  woTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton' },
    { key: 'workOrderId', label: 'Work Order(s)', type: 'dynamic', filter: false, validatorOrOpts: [Validators.required] },
  ];

  getNewObsXworkOrders() : QcObservationXworkOrders {
    var newWO = new QcObservationXworkOrders();
    newWO.workOrderId = 0;
    newWO.tenantId = null;
    newWO.observationXworkOrderId = 0;
    newWO.observationId = null;
    newWO.tenantId = 0
    return newWO;
  }
  defaultObsXworkOrders: QcObservationXworkOrders = this.getNewObsXworkOrders();

  jcnTablePermissions: AimsCommonTablePermissions = {
    create: true,
    update: false,
    delete: false,
    filter: false
  };
  jcnTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton' },
    { key: 'jobControlNumber', label: 'JCN(s)', type: 'dynamic', filter: false, validatorOrOpts: [Validators.required] },
  ];

  getNewObsXjcn() : QcObservationXjobControlNumbers {
    let retVal = new QcObservationXjobControlNumbers();
    retVal.observationId = 0;
    retVal.jobControlNumber = null;
    retVal.tenantId = 0;

    return retVal;
  }
  defaultObsXjcn: QcObservationXjobControlNumbers = this.getNewObsXjcn();

  destroy$: Subject<boolean> = new Subject();
  showJCNTab: boolean = this.transferHttp.tenantConfig.qc.showJCNTab;

  //***************************
  // Variables
  //***************************

  user = this.transferHttp.getCache(CacheItem.user);

  employeeValues = this.transferHttp.getCache(CacheItem.allEmployees);
  workOrderValues: Observable<Array<WoWorkOrders>>;
  //jcnValues: Observable<Array<Discrepancies>>;
  jcnValues: Array<Discrepancies>;
  pubValues = this.transferHttp.getSingle('QualityControl/GetPublicationsForPopUp');
  inspectionReportValues = this.transferHttp.getSingle<Array<QcInspectionReports>>('QualityControl/ViewInspectionReports');

  newObservation: BehaviorSubject<boolean> = new BehaviorSubject(false);
  saveClicked: boolean = false;

  rebuttal: boolean = false;
  rebuttalCommentTxt: string = null;

  workSectionLookupColumns: AimsCommonTableHeader[] = [
    { key: 'workSection', label: 'Work Section', type: AimsCommonTableHeaderType.STRING },
  ];

  workOrderLookupColumns: AimsCommonTableHeader[] = [
    { key: 'workOrderNumber', label: 'WO #', type: AimsCommonTableHeaderType.STRING },
    { key: 'origin', label: 'Origin', type: AimsCommonTableHeaderType.STRING },
    { key: 'workOrderType', label: 'Type', type: AimsCommonTableHeaderType.STRING },
    { key: 'description', label: 'Description', type: AimsCommonTableHeaderType.STRING },
    { key: 'status', label: 'Status', type: AimsCommonTableHeaderType.STRING },
    { key: 'classification', label: 'Classificaiton', type: AimsCommonTableHeaderType.STRING }
  ];

  jcnLookupColumns: AimsCommonTableHeader[] = [
    { key: 'jcn', label: 'JCN', type: AimsCommonTableHeaderType.STRING },
    { key: 'siteCode', label: 'SiteCode',type: AimsCommonTableHeaderType.STRING },
    { key: 'workSiteCode', label: 'WorkSiteCode', type: AimsCommonTableHeaderType.STRING },
    { key: 'discrepancy', label: 'Discrepancy', type: AimsCommonTableHeaderType.STRING }
  ];

  inspectionReportLookupColumns: AimsCommonTableHeader[] = [
    { key: 'reportName', label: 'Report Name', type: AimsCommonTableHeaderType.STRING},
    { key: 'strInspectionDate', label: 'Inspection Date', type: AimsCommonTableHeaderType.STRING },
    { key: 'siteCode', label: 'Site', type: AimsCommonTableHeaderType.STRING },
    { key: 'fullName', label: 'Primary Inspector', type: AimsCommonTableHeaderType.STRING }
  ];

  publicationLookupColumns: AimsCommonTableHeader[] = [
    { key: 'pubNum', label: 'Pub #', type: AimsCommonTableHeaderType.STRING },
    { key: 'pubTitle', label: 'Title', type: AimsCommonTableHeaderType.STRING },
    { key: 'pubIndexType', label: 'Type', type: AimsCommonTableHeaderType.STRING },
    { key: 'active', label: 'Active', type: AimsCommonTableHeaderType.BOOLEAN }
  ];

  //Spinner
  spinnerText: string = "Loading...";

  //DropDown Values, if isNew than only get ACTIVE values for the dropdowns using the combinLatest

  areaValues = combineLatest([
    this.newObservation,
    this.transferHttp.getSingle<Array<QcAreas>>('QualityControl/GetAreas')]).pipe(
      map(([isNew, areas]) => {
        return areas.filter(a => ((isNew) ? a.active : a.active !== null));
      }
    )
  );

  originTypeValues = combineLatest([
    this.newObservation,
    this.transferHttp.getSingle<Array<QcOriginTypes>>('QualityControl/GetOriginTypes')]).pipe(
      map(([isNew, oTypes]) => {
        return oTypes.filter(o => ((isNew) ? o.active : o.active !== null))
      }
    )
  );

  deficiencyTypeValues = combineLatest([
    this.newObservation,
    this.transferHttp.getSingle<Array<QcDeficiencyTypes>>('QualityControl/GetDeficiencyTypes')]).pipe(
      map(([isNew, rdTypes]) => {
        return rdTypes.filter(r => ((isNew) ? r.active : r.active !== null))
      }
    )
  );

  observationTypeValues = ObservationTypes;

  rootCauseValues = combineLatest([this.newObservation,
    this.transferHttp.getSingle<Array<QcRootCauses>>('QualityControl/GetRootCauses')]).pipe(
      map(([isNew, rootCauses]) => {
        return rootCauses.filter(r => ((isNew) ? r.active : r.active !== null))
      }
    )
  );

  responsibleManagerValues = combineLatest([
    this.newObservation,
    this.transferHttp.getSingle<Array<QcResponsibleManagers>>('QualityControl/GetResponsibleManagers')]).pipe(
      map(([isNew, resManagers]) => {
        return resManagers.filter(r => ((isNew) ? r.active : r.active !== null))
      }
    )
  );

  workSectionValues = combineLatest([
    this.newObservation,
    this.transferHttp.getSingle<Array<HrWorkSections>>('HR/GetWorkSections')]).pipe(
      map(([isNew, workSections]) => {
        return workSections.filter(w => ((isNew) ? w.active : w.active !== null))
      }
    )
  );

  siteValues = combineLatest([
    this.newObservation,
    this.transferHttp.getSingle<Array<AllSites>>('Sch/GetAllCompanyOrSanSites')]).pipe(
      map(([isNew, sites]) => {
        return sites.filter(w => ((isNew) ? w.active : w.active !== null))
      }
    )
  );

  observationCommentTypeValues = combineLatest([
    this.newObservation,
    this.transferHttp.getSingle<Array<QcObservationCommentTypes>>('QualityControl/GetObservationCommentTypes')]).pipe(
      map(([isNew, o]) => {
        return o.filter(o => {
          let include: boolean = true;
          if (isNew){
            include = o.active;
          }
          if (this.observation.observationTypeId == ObservationTypeEnum.cdi){
            include = !o.forCarsOnly;
          }
          return include;
        })

        // ((isNew) ? o.active : o.active !== null) && (this.observation.observationTypeId == ObservationTypeEnum.cdi)? !o.forCarsOnly )
      }
    )
  );

  newObservationComment(observationId: number): QcObservationComments {
    let retVal = new QcObservationComments();
    retVal.observationId = observationId;
    retVal.observationCommentTypeId = ObservationCommentTypeEnum.internalOnly;
    retVal.comment = null;
    retVal.attachment = null;
    retVal.attachmentName = null;
    retVal.attachmentType = null;
    retVal.commentDate = new Date();
    retVal.commentById = this.user.employeeId;

    this.rebuttal = false;

    return retVal;
  }

  observation: QcObservations = new QcObservations();
  @ViewChild('obsForm', { static: false }) obsForm: NgForm;

  //***************************
  // Functions
  //***************************

  //Rebuttal Comment
  public doRebuttalComment(): void {
    this.rebuttal = true;

    const dialogRef = this.dialog.open(AimsCommonPopupEditorComponent, {
        width: '460px',
        data: {
          header: '',
          content: RebuttalCommentDialogComponent,
          contentData: { },
        },
        disableClose: true,
      })

      dialogRef.afterClosed().subscribe((dialogResult) => {
        if (dialogResult) {
          this.rebuttalCommentTxt = dialogResult.rebuttalComment;

          this.addRebuttalComment();
        }
        else {
          this.cancelRebuttalComment();
        }
      });

  }

  public cancelRebuttalComment(): void {
    this.rebuttalCommentTxt = null;
    this.rebuttal = false;
  }

  public addRebuttalComment(): void {

    let rebuttalComment = this.newObservationComment(this.observation.observationId);

    rebuttalComment.comment = this.rebuttalCommentTxt;
    rebuttalComment.observationCommentTypeId = ObservationCommentTypeEnum.rebuttal;

    //Insert comment
    this.transferHttp.put(`QualityControl/SaveRebuttalComments`, rebuttalComment).subscribe(retVal => {
      this.rebuttal = false;
      this.rebuttalCommentTxt = null;
      this.loadObservation(this.observation.observationId);
    });
  }

  public showQaFields: BehaviorSubject<boolean> = new BehaviorSubject(false);


  public isCAR(): boolean {
    return (this.observation.observationTypeId == ObservationTypeEnum.car);
  }

  public isCDI(): boolean {
    return (this.observation.observationTypeId == ObservationTypeEnum.cdi);
  }

  public canViewWorkOrders(): boolean {
    return (this.permissions.canRead(this.permissions.ComponentID.ViewWorkOrders));
  }

  public canUpdate(): boolean {
    return (this.observation.finalReviewDate != null && this.permissions.canUpdate(this.permissions.ComponentID.Observations));
  }

  public canCreate(): boolean {
    return (this.observation.finalReviewDate == null && this.permissions.canCreate(this.permissions.ComponentID.Observations));
  }

  public qcFinalApproved(): boolean {
    return this.observation.finalReviewDate != null;
  }

  public canQcApprove(): boolean {
    let returnVal = false;

    if (this.observation.finalReviewDate == null && this.permissions.canUpdate(this.permissions.ComponentID.QualityControl)) {
      returnVal = true;
    }
    return returnVal;
  }

  public canPmmApproveOrReject(): boolean {
    let returnVal = false;

    if (this.observation.finalReviewDate == null) {
      returnVal = false;
    }
    else if (this.observation.observationTypeId == ObservationTypeEnum.car && this.observation.projMngrReviewedDate == null && this.permissions.canUpdate(this.permissions.ComponentID.CarFinalApproval)) {
      returnVal = true;
    }
    return returnVal;
  }

  public pmmRejected(): void {
    this.observation.finalReviewDate = null;
    this.saveObservation();
    this.doRebuttalComment();
  }

  public qcFinalApproval() {
    this.observation.finalReviewDate = new Date();
    this.saveObservation();
  }

  public pmmFinalApproval() {
    this.observation.projMngrReviewedDate = new Date();
    this.saveObservation();
  }

  public originChanged(event) {
    let oId = event.value;
    this.originTypeValues.subscribe(
    otv => {
      if (oId != null) {
        const selectedOriginType = otv.filter(o => o.originTypeId == oId)[0];
        if (selectedOriginType.defaultToCdi) {
          this.observation.observationTypeId = ObservationTypeEnum.cdi;
          this.observation.isValid = true;
        }
        else{
          this.observation.observationTypeId = null;
        }
        if (selectedOriginType.showQafields){
          this.showQaFields.next(true);
        }
        else {
          this.showQaFields.next(false);
        }
      }
    });

  }



  public rdtChanged(): void {
    if (this.newObservation.value) {
      if (this.observation.deficiencyTypeId == DeficiencyEnum.critical) {
        this.observation.workSectionSuspenseDate = moment(this.observation.openedDate).add(3, 'days').toDate();
      }
      else if (this.observation.deficiencyTypeId == DeficiencyEnum.major) {
        this.observation.workSectionSuspenseDate = moment(this.observation.openedDate).add(7, 'days').toDate();
      }
      else {
        this.observation.workSectionSuspenseDate = moment(this.observation.openedDate).add(10, 'days').toDate();
      }
    }
  }

  public inspRptChanged(irId): void {
    if (irId != null) {
      this.inspectionReportValues.subscribe(r => {
        let f = r.filter(ir => ir.inspectionReportId == irId)[0];
        if (f !== undefined) {
          this.observation.siteId = f.siteId;
          this.observation.inspectionDate = f.inspectionDate;
        }
      })
    }
  }


  showSpinner: boolean; //BehaviorSubject<boolean> = new BehaviorSubject(false);
  showProgress: boolean;

  calculateEditable() {
    let returnVal = false;

    if (this.permissions.canUpdate(this.permissions.ComponentID.Observations)) {
      if (this.observation.projMngrReviewedDate != null) {
        returnVal = false;
      }
      else if (this.observation.observationTypeId == ObservationTypeEnum.car &&
        (this.newObservation.value ||
          (this.observation.rootCauseId == null &&
            this.observation.finalReviewDate == null))) {
        returnVal = true;
      }
      else if (this.observation.observationTypeId == ObservationTypeEnum.cdi &&
        this.newObservation.value || this.observation.finalReviewDate == null) {
        returnVal = true;
      }
    }
    return returnVal;
  }

  canDelete() {
    let returnVal = false;

    if (this.permissions.canDelete(this.permissions.ComponentID.QualityControl)) {
      returnVal = true;
    }
    return returnVal;
  }


  //Cancel
  public cancelObsUpdate() {
    var message = this.messageService.getDialogMessage(DialogComponent.UnsavedChanges);
    let dialogRef = this.dialog.open(AimsCommonConfirmDialogComponent,{
      data: message
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if(dialogResult){
        this.router.navigate(['/projectSupport']);
      }
      dialogRef = null;
    });
  }

  //Save Observation
  saveObservation() {
    this.saveClicked = true;
    this.showSpinner = true;
    let saving$: Subscription = this.transferHttp.put(`QualityControl/SaveObservation`, this.observation).subscribe({
      next: ret => {
      this.loadObservation(ret.id);
      saving$.unsubscribe();
      },
      error: _ => {
        this.showSpinner = false;
      }
    });
  }

  loadObservation(observationId: number) {
    this.showSpinner = true;
    this.router.navigate(['/projectSupport/observation/' + observationId]); //added so, you can create another Observation back to back without navigating away
    this.saveClicked = false;
    this.newObservation.next(false);
    this.transferHttp.getSingle<QcObservations>(`QualityControl/GetObservation?observationId=${observationId}`).subscribe(retVal => {
      this.observation = retVal;
      this.workOrderValues = this.transferHttp.getSingle(`QualityControl/GetAllWorkOrdersBySite?siteId=${this.observation.siteId}`);
      this.workOrderValues.subscribe();
      this.transferHttp.getSingle(`https://www.arctecalaska.com/AIMSApi/api/QualityControl/GetAllJobControlNumbersBySiteCode?siteCode=${this.observation.site.siteCode}`)
      .subscribe(ret => {
        this.jcnValues =  ret;
      })
      //this.jcnValues.subscribe();

      this.workSectionValues.pipe(take(1)).subscribe();
//      this.observationCommentTypeValues.subscribe();

      this.showSpinner = false;

      this.observation.qcObservationRequiredActions.sort((a, b) => (a.orderNumber > b.orderNumber) ? 1 : -1);
      if (this.obsForm) {
        this.obsForm.form.markAsPristine();
      }

      this.updateActionTablePermissions();
      this.updateCommentTablePermissions();
      this.updateAttachmentsTablePermissions();
      this.updateWoTablePermissions();
      this.updateJcnTablePermissions();

      // upload any pending attachments
      this.uploadCommentAttachments();
      this.uploadAttachments();
    });
  }

  public createObservation() {

    //Set defaults
    this.originTypeValues.subscribe();
    this.deficiencyTypeValues.subscribe();
    this.observationCommentTypeValues.subscribe();
    this.workSectionValues.pipe(take(1)).subscribe();
    this.areaValues.subscribe();

    this.newObservation.next(true);
    this.observation.originTypeId = null;
    this.observation.deficiencyTypeId = null;
    this.observation.observationTypeId = null;
    this.observation.responsibleManagerId = null;
    this.observation.workSectionId = null;
    this.observation.areaId = null;
    this.observation.rootCauseId = null;
    this.observation.openedDate = new Date();
    this.observation.workSectionSuspenseDate = null;
    this.observation.isValid = false;

    this.updateCommentTablePermissions();
    this.updateActionTablePermissions();
    this.updateAttachmentsTablePermissions();
    this.updateWoTablePermissions();
    this.updateJcnTablePermissions();
  }

  // JCN Table funcs
  private updateJcnTablePermissions() {
    this.jcnTablePermissions.delete =  this.calculateEditable() && this.canDelete();
    this.jcnTablePermissions.update =  this.calculateEditable();
    this.jcnTablePermissions.create =  this.calculateEditable();
  }

  public jcnRowAdded(update: TableRowUpdate) {
    const newJcn: QcObservationXjobControlNumbers = update.newRow as QcObservationXjobControlNumbers;
    newJcn.observationId = this.observation.observationId;
    this.observation.qcObservationXjobControlNumbers = [newJcn, ...this.observation.qcObservationXjobControlNumbers];
    this.obsForm.form.markAsDirty();
  }

  public jcnRowUpdated(update: TableRowUpdate) {
    const updatedLineItem: QcObservationXjobControlNumbers = update.newRow as QcObservationXjobControlNumbers;

    this.observation.qcObservationXjobControlNumbers[update.index] = updatedLineItem;
    this.observation.qcObservationXjobControlNumbers = [...this.observation.qcObservationXjobControlNumbers];

    this.obsForm.form.markAsDirty();
  }

  public jcnRowDeleted(deleted: TableRowDelete) {
    this.observation.qcObservationXjobControlNumbers.splice(deleted.index, 1);
    this.observation.qcObservationXjobControlNumbers = [...this.observation.qcObservationXjobControlNumbers];
    this.obsForm.form.markAsDirty();
  }

  // WO Table
  public woRowAdded(update: TableRowUpdate) {
    const newWorkOrder: QcObservationXworkOrders = update.newRow as QcObservationXworkOrders;
    newWorkOrder.observationId = this.observation.observationId;
    this.observation.qcObservationXworkOrders = [newWorkOrder, ...this.observation.qcObservationXworkOrders];
    this.obsForm.form.markAsDirty();
  }

  public woRowUpdated(update: TableRowUpdate) {
    const updatedLineItem: QcObservationXworkOrders = update.newRow as QcObservationXworkOrders;

    this.observation.qcObservationXworkOrders[update.index] = updatedLineItem;
    this.observation.qcObservationXworkOrders= [...this.observation.qcObservationXworkOrders];

    this.obsForm.form.markAsDirty();
  }

  public woRowDeleted(deleted: TableRowDelete) {
    this.observation.qcObservationXworkOrders.splice(deleted.index, 1);
    this.observation.qcObservationXworkOrders = [...this.observation.qcObservationXworkOrders];
    this.obsForm.form.markAsDirty();
  }

  private updateWoTablePermissions() {
    this.woTablePermissions.delete =  this.calculateEditable() && this.canDelete();
    this.woTablePermissions.update =  this.calculateEditable();
    this.woTablePermissions.create =  this.calculateEditable();
  }

  // Attachments table
  private updateAttachmentsTablePermissions() {
    this.attachmentsTablePermissions.create =  this.calculateEditable();
    this.attachmentsTablePermissions.update =  this.calculateEditable();
    this.attachmentsTablePermissions.delete =  this.calculateEditable();
  }

  attachmentFilesToUpdate: Array<FileToUpdate> = [];
  attachmentFileTempId: number = 0;

  public attachmentRowUpdated(update: TableRowUpdate) {
    let fileGridCmd :FileGridCmd = update.newRow['attachment'] as FileGridCmd;
    let files:FileList = fileGridCmd.files as FileList;

    const updatedLineItem: QcObservationAttachments = update.newRow as QcObservationAttachments;

     if (fileGridCmd.action == FileGridCmds.add) {
      let fileToUpdate = new FileToUpdate();
      fileToUpdate.files = files;
      fileToUpdate.id = `upd${this.attachmentFileTempId++}`;
      this.attachmentFilesToUpdate.push(fileToUpdate);
      updatedLineItem.attachmentType = fileToUpdate.id; // abuse attachemnt type, server will fill in proper data
      updatedLineItem.attachmentName = fileToUpdate.files[0].name;
    }
    else if (fileGridCmd.action == FileGridCmds.delete) {
      // file has been deleted
      updatedLineItem.attachmentType = null;
      updatedLineItem.attachmentName = null;
    }

    updatedLineItem.attachment = null;

    this.observation.qcObservationAttachments[update.index] = updatedLineItem;
    this.observation.qcObservationAttachments = [...this.observation.qcObservationAttachments];

    this.obsForm.form.markAsDirty();
  }

  public attachmentRowAdded(update: TableRowUpdate) {
    let fileGridCmd :FileGridCmd = update.newRow['attachment'] as FileGridCmd;
    const newAttachment: QcObservationAttachments = update.newRow as QcObservationAttachments;

    if (fileGridCmd.action == FileGridCmds.add) {
      let fileToUpdate = new FileToUpdate();
      fileToUpdate.files = fileGridCmd.files as FileList;
      fileToUpdate.id = `upd${this.attachmentFileTempId++}`;
      this.attachmentFilesToUpdate.push(fileToUpdate);
      newAttachment.attachmentType = fileToUpdate.id; // abuse attachemnt type, server will fill in proper data
      newAttachment.attachmentName = fileToUpdate.files[0].name;
    }
    else if (fileGridCmd.action == FileGridCmds.delete) {
      // file has been deleted
      newAttachment.attachmentType = null;
      newAttachment.attachment = null;
      newAttachment.attachmentName = null;
    }

    newAttachment.attachment = null;

    newAttachment.observationId = this.observation.observationId;
    newAttachment.addedById = this.user.employeeId;
    newAttachment.attachmentId = 0;

    this.observation.qcObservationAttachments = [newAttachment, ...this.observation.qcObservationAttachments];

    this.obsForm.form.markAsDirty();
  }

  public attachmentRowDeleted(deleted: TableRowDelete) {
    this.observation.qcObservationAttachments.splice(deleted.index, 1);
    this.observation.qcObservationAttachments = [...this.observation.qcObservationAttachments];
    this.obsForm.form.markAsDirty();
  }

  // Required Action table funcs
  public actionRowEdit(update: TableRowUpdate) {
    this.updateActionTableFields(update.oldData[update.index])
  }

  public actionRowUpdated(update: TableRowUpdate) {
    const updatedLineItem: QcObservationRequiredActions = update.newRow as QcObservationRequiredActions;
    if (updatedLineItem.completedOn != null && updatedLineItem.completedById == null) {
      updatedLineItem.completedById = this.user.employeeId;
    }

    if (updatedLineItem.certifiedOn != null && updatedLineItem.certifiedById == null) {
      updatedLineItem.certifiedById = this.user.employeeId;
    }

    this.observation.qcObservationRequiredActions[update.index] = updatedLineItem;
    this.observation.qcObservationRequiredActions = [...this.observation.qcObservationRequiredActions]

    this.obsForm.form.markAsDirty();
  }

  public actionRowAdded(update: TableRowUpdate) {
    const newAction: QcObservationRequiredActions = update.newRow as QcObservationRequiredActions;
    if (newAction.completedOn != null && newAction.completedById == null) {
      newAction.completedById = this.user.employeeId;
    }

    let requiredActions = this.observation.qcObservationRequiredActions;
    let lastOrderNumber = 0;

    requiredActions.forEach(ra => {
      if (ra.orderNumber > lastOrderNumber) {
        lastOrderNumber = ra.orderNumber;
      }
    });

    lastOrderNumber = ++lastOrderNumber;

    newAction.observationId = this.observation.observationId;
    newAction.orderNumber = lastOrderNumber;

    this.observation.qcObservationRequiredActions = [newAction, ...this.observation.qcObservationRequiredActions]

    this.obsForm.form.markAsDirty();
  }

  public actionRowDeleted(deleted: TableRowDelete) {
    this.observation.qcObservationRequiredActions.splice(deleted.index, 1);
    this.observation.qcObservationRequiredActions = [...this.observation.qcObservationRequiredActions];
    this.obsForm.form.markAsDirty();
  }

  public updateActionTableFields(element) {
    var column = this.actionTableHeader.find(el => el.key == 'requiredAction');
    column.editable = element.completedById == null && this.calculateEditable();

    column = this.actionTableHeader.find(el => el.key == 'completedOn');
    column.editable = this.calculateEditable();

    column = this.actionTableHeader.find(el => el.key == 'certifiedOn');
    column.editable = !(this.user.employeeId == element.completedById || element.completedOn == null) && this.calculateEditable();

    this.actionTableHeader = [...this.actionTableHeader];
  }

  private updateActionTablePermissions() {
    this.actionTablePermissions.delete =  this.calculateEditable() && this.canDelete();
    this.actionTablePermissions.update =  this.calculateEditable();
  }


  commentFilesToUpdate: Array<FileToUpdate> = [];
  commentFileTempId: number = 0;

  // comment table methods
  public commentRowUpdated(update: TableRowUpdate) {
    let fileGridCmd :FileGridCmd = update.newRow['attachment'] as FileGridCmd;
    let files:FileList = fileGridCmd.files as FileList;

    const updatedLineItem: QcObservationComments = update.newRow as QcObservationComments;

    if (fileGridCmd.action == FileGridCmds.add) {
      let fileToUpdate = new FileToUpdate();
      fileToUpdate.files = files;
      fileToUpdate.id = `upd${this.commentFileTempId++}`;
      this.commentFilesToUpdate.push(fileToUpdate);
      updatedLineItem.attachmentType = fileToUpdate.id; // abuse attachemnt type, server will fill in proper data
      updatedLineItem.attachmentName = fileToUpdate.files[0].name;
      updatedLineItem.attachmentAddedById = this.user.employeeId;
    }
    else if (fileGridCmd.action == FileGridCmds.delete) {
      // file has been deleted
      updatedLineItem.attachmentType = null;
      updatedLineItem.attachmentName = null;
      updatedLineItem.attachmentAddedById = null;
    }

    updatedLineItem.attachment = [];

    this.observation.qcObservationComments[update.index] = updatedLineItem;
    this.observation.qcObservationComments = [...this.observation.qcObservationComments]

    this.obsForm.form.markAsDirty();
  }

  public commentRowAdded(update: TableRowUpdate) {
    let fileGridCmd :FileGridCmd = update.newRow['attachment'] as FileGridCmd;

    const newComment: QcObservationComments = update.newRow as QcObservationComments;
    newComment.attachment = [];

    if (fileGridCmd.action == FileGridCmds.add) {
      let fileToUpdate = new FileToUpdate();
      fileToUpdate.files = fileGridCmd.files as FileList;
      fileToUpdate.id = `upd${this.commentFileTempId++}`;
      this.commentFilesToUpdate.push(fileToUpdate);
      newComment.attachmentType = fileToUpdate.id; // abuse attachemnt type, server will fill in proper data
      newComment.attachmentName = fileToUpdate.files[0].name;
      newComment.attachmentAddedById = this.user.employeeId;
    }
    else if (fileGridCmd.action == FileGridCmds.delete) {
      // file has been deleted
      newComment.attachmentType = null;
      newComment.attachment = null;
      newComment.attachmentName = null;
      newComment.attachmentAddedById = null;
    }

    newComment.observationId = this.observation.observationId;
    newComment.commentDate = new Date();
    newComment.commentById = this.user.employeeId;

    this.observation.qcObservationComments = [newComment, ...this.observation.qcObservationComments];

    this.obsForm.form.markAsDirty();
  }

  public commentRowEdit(update: TableRowUpdate) {
    this.updateCommentTableFields(update.oldData[update.index])
  }

  private updateCommentTablePermissions() {
    this.commentTablePermissions.create =  this.calculateEditable();
    this.commentTablePermissions.update =  this.calculateEditable();
  }

  public updateCommentTableFields(element) {
    var column = this.commentTableHeader.find(el => el.key == 'comment');
    column.editable = element.commentById == this.user.employeeId || element.commentById == null;

    this.actionTableHeader = [...this.actionTableHeader];
  }

  uploadCommentAttachments() {
    const upSubj: BehaviorSubject<number> = new BehaviorSubject(0);
    upSubj.subscribe(val => {
      this.uploadProgress = val;
      if (this.uploadProgress == 100) {
        setTimeout(() => { this.showProgress = false}, 1000);
      }
    });

    const uploader: FileUploader = new FileUploader(this.transferHttp);
    const saveUrl:string ='QualityControl/SaveObservationCommentAttachment?observationCommentId=';

    this.commentFilesToUpdate.forEach(f => {
      const obComment = this.observation.qcObservationComments.find(oc => oc.attachmentType == f.id);

      if (obComment) {
        this.showProgress = true;
        this.uploadFileName = f.files[0].name;
        const completeSaveUrl = saveUrl + obComment.observationCommentId;
        uploader.uploadFiles(f.files, completeSaveUrl, upSubj);
      }
    });

    this.commentFilesToUpdate = [];
  }

  // used by upload progress bar popup
  public uploadProgress: number = 0;
  public uploadFileName: string;

  uploadAttachments() {
    const upSubj: BehaviorSubject<number> = new BehaviorSubject(0);
    upSubj.subscribe(val => {
      this.uploadProgress = val;
      if (this.uploadProgress == 100) {
        setTimeout(() => { this.showProgress = false}, 500);
      }
    });

    const uploader: FileUploader = new FileUploader(this.transferHttp);
    const saveUrl:string ='QualityControl/SaveObservationAttachment?attachmentId=';

    this.attachmentFilesToUpdate.forEach(f => {
      const obAttachment = this.observation.qcObservationAttachments.find(oc => oc.attachmentType == f.id);

      if (obAttachment) {
        this.showProgress = true;
        this.uploadFileName = f.files[0].name;
        const completeSaveUrl = saveUrl + obAttachment.attachmentId;
        uploader.uploadFiles(f.files, completeSaveUrl, upSubj);
      }
    });

    this.attachmentFilesToUpdate = [];
  }

  //***************************
  // Init
  //***************************

  ngOnInit() {
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe(p => {
      if (p['observationId'] != null) {
        this.loadObservation(p['observationId']);
      }
      else {
        this.createObservation();
      }

    });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}

class FileToUpdate {
    files:FileList;
    id: string;
}

// class FileUploader {
//   //saveUrl: string;

//   uploadProgress: number = null
//   uploadSub: Subscription

//   constructor(private transferHttp: TransferHttpService) {

//   }

//   public uploadFiles(files: FileList, saveUrl: string) {
//     if (files.length == 0) {
//       console.log('No file selected!')
//       return
//     }

//     let file: File = files[0]

//     const formData = new FormData()
//     formData.append('Files', file)

//     const upload$ = this.transferHttp
//       .post(saveUrl, formData, {
//         reportProgress: true,
//         observe: 'events',
//       })
//       .pipe(finalize(() => this.reset()))

//     this.uploadSub = upload$.subscribe(
//       (event) => {
//         if (event.type == HttpEventType.UploadProgress) {
//           this.uploadProgress = Math.round(100 * (event.loaded / event.total))
//           console.log(`File is ${this.uploadProgress}% loaded.`)
//         } else if (event instanceof HttpResponse) {
//           // this.success.emit()
//         }
//       },
//       (err) => {
//         console.log('Upload Error:', err)
//       }
//     )
//   }

//   cancelUpload() {
//     this.uploadSub?.unsubscribe()
//     this.reset()
//   }

//   reset() {
//   }

// }
